const PAYMENT_INVOICES_LOAD_REQUEST = 'PAYMENT_INVOICES_LOAD_REQUEST';
const PAYMENTS_INVOICES_LOAD_SUCCESS = 'PAYMENTS_INVOICES_LOAD_SUCCESS';

const PAYMENT_INVOICES_LOAD_URL = '/payment/invoice/load';
const PAYMENT_INVOICES_REQUEST_ORIGINALS_URL = '/payment/input-invoice-ua/request-originals';
const PAYMENT_INVOICES_REQUEST_ORIGINALS_VCHASNO_URL = '/payment/input-invoice-ua/request-originals-vchasno';

const REDUCER_PAYMENT_INVOICES_NAME = 'paymentInvoices';

const PAYMENT_INVOICES_URL = '/payment/invoices';

export {
  PAYMENT_INVOICES_LOAD_REQUEST,
  PAYMENTS_INVOICES_LOAD_SUCCESS,

  PAYMENT_INVOICES_LOAD_URL,
  PAYMENT_INVOICES_REQUEST_ORIGINALS_URL,
  PAYMENT_INVOICES_REQUEST_ORIGINALS_VCHASNO_URL,

  REDUCER_PAYMENT_INVOICES_NAME,

  PAYMENT_INVOICES_URL,
};
